export default "https://legacy.eskolare-development.com/images/upload-file.png";